(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../steps/constant"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../steps/constant"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.constant);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _constant) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: {
          'nx-steps--item': true,
          active: _vm.active
        }
      }, [_c('div', {
        staticClass: "nx-steps--item--icon",
        style: {
          backgroundImage: _vm.iconUrl
        }
      }), _c('div', {
        staticClass: "nx-steps--item--name"
      }, [_vm._v(_vm._s(_vm.name))]), _c('div', {
        staticClass: "nx-steps--item--description"
      }, [_vm._v(_vm._s(_vm.description))])]);
    },
    name: 'nx-steps-item',
    props: {
      name: String,
      description: String,
      status: String,
      activeIconUrl: String,
      waitIconUrl: String
    },
    data: function data() {
      return {
        currentStatus: '',
        currentStepNumber: 0
      };
    },
    computed: {
      active: function active() {
        return this.currentStatus === _constant.STEPS_ITEM_STATUS.FINISH || this.currentStatus === _constant.STEPS_ITEM_STATUS.PROCESS;
      },
      iconUrl: function iconUrl() {
        var active = this.currentStatus === _constant.STEPS_ITEM_STATUS.FINISH || this.currentStatus === _constant.STEPS_ITEM_STATUS.PROCESS;
        if (active && this.activeIconUrl) return "url(".concat(this.activeIconUrl, ")");else if (!active && this.waitIconUrl) return "url(".concat(this.waitIconUrl, ")");else return '';
      }
    },
    created: function created() {
      this.currentStatus = this.status;
    }
  };
  _exports.default = _default;
});